import type { EmptyObject } from '@/utils/primitives'
import type { NodeAttributes } from '../tiptap-helpers'

import { Node } from '@tiptap/core'
import { ReactNodeViewRenderer, mergeAttributes } from '@tiptap/react'

import {
  VARIABLENODE_NAME,
  VARIABLENODE_TAG,
  VARIABLENODE_TAG_LEGACY,
} from './variables.config'

import { VariableNodeViewLive } from './VariableNodeView'
import { createVariablesSuggestion } from './VariablesSuggestions'

type VariableNodeOptions = EmptyObject

export type VariableNodeAttributes = {
  variableKey: string
  fallbackValue: string
}

export const VariableNode = Node.create<
  VariableNodeOptions,
  VariableNodeAttributes
>({
  name: VARIABLENODE_NAME,
  group: 'inline',
  atom: true,
  isolating: true,
  inline: true,
  selectable: false,
  defining: true,

  addAttributes() {
    return {
      variableKey: {
        parseHTML: (element) => element.getAttribute('data-variable-key'),
        renderHTML: (attributes) => {
          if (!attributes.variableKey) return {}

          return { 'data-variable-key': attributes.variableKey }
        },
      },
      // Fallback name to use after the mention was deleted
      fallbackValue: {
        parseHTML: (element) => element.getAttribute('data-fallback-value'),
        renderHTML: (attributes) => {
          if (!attributes.fallbackValue) return {}

          return { 'data-fallback-value': attributes.fallbackValue }
        },
      },
    } satisfies NodeAttributes<VariableNodeAttributes>
  },

  parseHTML() {
    return [
      { tag: VARIABLENODE_TAG },
      { tag: VARIABLENODE_TAG_LEGACY }, // Parse legacy tag during migration period
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [VARIABLENODE_TAG, mergeAttributes(HTMLAttributes)]
  },

  addNodeView() {
    return ReactNodeViewRenderer(VariableNodeViewLive)
  },

  addProseMirrorPlugins(this) {
    return [
      createVariablesSuggestion({
        name: this.name,
        editor: this.editor,
      }),
    ]
  },
})
